import { observable, action, computed } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../../services/web/agent';
import erorrHandler from '../../services/web/erorrHandler';
import AuthenticationProviderType from '../../services/enums/authenticationProviderType';

class DirectoryUserMappingStore {

    @setter @observable usersEntries;
    @setter @observable directories;
    @setter @observable containsPattern = '';
    @setter @observable selectedAuthProviderId;

    @setter @observable getUserEntriesProgress;
    @setter @observable getUserEntriesErrorMessage;

    @action getUserEntries(directoryId, containsPattern) {

        this.getUserEntriesProgress = true;

        return this.getUserEntriesByProviderType(directoryId, containsPattern)
            .then(action((usersEntries) => {
                
                this.usersEntries = usersEntries;
            }))
            .catch(action((err) => {

                this.getUserEntriesErrorMessage = erorrHandler.getErrorMessage(err);
        
                throw err;
            }))
            .finally(action(() => {
                this.getUserEntriesProgress = false;
            }));
        
    }
    
    getUserEntriesByProviderType(directoryId, containsPattern) {
        
        if(this.selectedProviderType.toLowerCase() === AuthenticationProviderType.LDAP.toLowerCase()){

            return agent.LDAPUserEntries.get(directoryId, containsPattern);
        }

        return agent.DomainUserEntries.get(directoryId, containsPattern);
    }

    @computed get selectedProviderId() {

        if (this.directories) {
            
            const result = this.directories.filter((s) => s.id == this.selectedAuthProviderId);

            if (result.length > 0) {
                
                return result[0].providerId;
            }
        }
    }

    @computed get selectedProviderType() {

        if (this.directories) {
            
            const result = this.directories.filter((s) => s.id == this.selectedAuthProviderId);

            if (result.length > 0) {
                
                return result[0].providerType;
            }
        }
    }

    @action resetForm = () => {

        this.usersEntries = undefined;
        this.containsPattern = '';
    }
}

export default new DirectoryUserMappingStore();


// WEBPACK FOOTER //
// ./src/stores/directoryUserMapping/index.js